<template>
    <div class="my-step">
        <dl class="my-step__msg">
            <dt>初赛成绩</dt>
            <dd v-if="isBefore(preRes)">{{preRes|time2text}}公布初赛排名、晋级名单、<br>获奖名单</dd>
            <dd v-else-if="preScore > 0">
                你排名<k-txt-rank :value="preRank" />，得分<span class="red">{{preScore}}</span>，<k-txt-advance :value="isAdvance" />
            </dd>
        </dl>

        <div class="my-step__btn">
            <router-link v-if="nowTime > preRes" class="active" tag="a" to="/match/pre">晋级名单</router-link>
            <a v-else href="javascript:;">晋级名单</a>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: 'my-step-pre-res',
        computed: {

            ...mapGetters(['nowTime', 'isBefore', 'isAfter', 'signBegin', 'preBegin', 'preEnd', 'preRes', 'finalBegin',
                'finalEnd',
                'finalRes',
                'awardTime', 'finishCupNum', 'allCupNum',
                'isAdvance', 'isFinishFinal',
                'preRank', 'preScore', 'finalRank', 'finalScore', 'maxAvgScore'
            ]),
        },
        methods: {
            ...mapActions(['goPrePlay'])
        }
    };

</script>
